export default "__VITE_PUBLIC_ASSET__83ca27ab__"